// extracted by mini-css-extract-plugin
export default {"userWrapper":"Users_userWrapper__eCxWG","userDesc":"Users_userDesc__zdicz","user":"Users_user__u9QXI","userBtn":"Users_userBtn__vlxRX"};